import React, { useState, useEffect, use } from "react";
import GenericForm from "./GenericForm";
import "bootstrap/dist/css/bootstrap.min.css";
import "../assets/css/style.css";
import userImage from "../assets/img/user.png";
import customerInformation from "../assets/img/customer_information.svg";
import basic from "../assets/img/basic.svg";
import collection from "../assets/img/collection.svg";
import payment from "../assets/img/payment.svg";
import check from "../assets/img/ckeck.svg";
import formConfig from "../config/formConfig";
import SummaryPage from "./SummaryPage";
import { SampleData } from "../config/SampleData";
import { useNavigate } from "react-router-dom";
import RmForm from "./RmForm";
const Stepper = () => {
  const navigate = useNavigate();
  const [currentStep, setCurrentStep] = useState(1);
  const [steps, setSteps] = useState(
    SampleData.find((item) => item?.segment === "Education").steps
  );
  const [customerSegment, setCustomerSegment] = useState("Education");
  const [productList, setProductList] = useState([]);
  const [showRmForm, setShowRmForm] = useState(false);
  const [currentQuestionType, setCurrentQuestionType] = useState("");
  const handleNext = (childData) => {
    let tempCurrentSegment = "";
    if (currentStep === 1) {
      tempCurrentSegment = childData.find(
        (item) => item.name === "customerSegment"
      )?.answer;
      setCustomerSegment(tempCurrentSegment);
      let tempSteps = SampleData.find(
        (item) => item?.segment === tempCurrentSegment
      );
      tempSteps?.steps?.map((step, index) => {
        if (currentStep === index + 1) {
          step.question = [...childData];
        }
        return step;
      });
      setSteps(tempSteps?.steps);
    } else {
      let tempSteps = [...steps];
      tempSteps[currentStep - 1].question = [...childData];
      setSteps(tempSteps);
    }
    setCurrentStep((prevStep) => prevStep + 1);
  };

  const handlePrevious = (childData) => {
    if (childData) {
      if (currentStep === 1) {
        navigate("/customerscreen");
      } else {
        let tempSteps = [...steps];
        tempSteps[currentStep - 1].question = [...childData];
        setSteps(tempSteps);
        setCurrentStep((prevStep) => prevStep - 1);
      }
    } else {
      setCurrentStep((prevStep) => prevStep - 1);
    }
  };

  const resetData = (value) => {
    let temp = SampleData.find((item) => item?.segment === value).steps;
    temp?.map((step) => {
      step.question?.map((q) => {
        q.answer = "";
      });
    });
    temp[0].question?.map((q) => {
      if (q?.name === "customerSegment") {
        q.answer = value;
      }
    });
    setSteps(temp);
  };

  return (
    <section className="multistep_sec">
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12">
            <div className="menu_link_section">
              <div className="link">
                <ul>
                  {steps?.map((step, index) => (
                    <li
                      key={index}
                      className={currentStep === index + 1 ? "active" : ""}
                    >
                      <a href="#">
                        <img src={step?.icon} alt={step?.name} />
                        <span>{step?.name}</span>
                        <div className="count_pro">
                          {currentStep > index + 1 ? (
                            <p
                              style={{
                                backgroundColor: "#44E768",
                                borderRadius: "15px",
                                color: "#ffffff",
                              }}
                            >
                              &#10003;
                            </p>
                          ) : (
                            <p>{index + 1}</p>
                          )}
                        </div>
                      </a>
                    </li>
                  ))}
                </ul>
                <div className="progress-container">
                  <div
                    className="progress"
                    id="progress"
                    style={{
                      width: `${
                        ((currentStep - 1) / (steps?.length - 1)) * 100
                      }%`,
                    }}
                  ></div>
                </div>
              </div>
              {/*  */}
              <div className="content_box">
                <div className="form-card">
                  <div className="row align-items-center">
                    {steps?.[currentStep - 1]?.name !== "Summary Page" &&
                      currentQuestionType !== "start" && (
                        <div className="col-md-4">
                          <div className="cus_img">
                            <img src={userImage} className="w-100" alt="User" />
                          </div>
                        </div>
                      )}
                    <div
                      className={
                        steps?.[currentStep - 1]?.name !== "Summary Page" &&
                        currentQuestionType !== "start"
                          ? "col-md-8"
                          : "col-md-12"
                      }
                    >
                      {steps?.[currentStep - 1]?.name !== "Summary Page" ? (
                        <GenericForm
                          onNext={handleNext}
                          onPrevious={handlePrevious}
                          questions={steps?.[currentStep - 1]?.question}
                          onSkipComponent={(questionType) => {
                            setCurrentQuestionType(questionType);
                          }}
                          resetData={resetData}
                        />
                      ) : showRmForm === false ? (
                        <SummaryPage
                          onNext={(data) => {
                            setProductList(data);
                            setShowRmForm((prev) => !prev);
                          }}
                          onPrevious={handlePrevious}
                          questions={steps?.[currentStep - 1]?.question}
                        />
                      ) : (
                        <RmForm
                          steps={steps}
                          productList={productList}
                          onPrevious={() => {
                            setShowRmForm((prev) => !prev);
                            handlePrevious();
                          }}
                          onCancel={() => setShowRmForm((prev) => !prev)}
                        />
                      )}
                      {/* <CurrentComponent
                        currentSubStep={currentSubStep}
                        onNext={handleNext}
                        onPrevious={handlePrevious}
                        questions={currentQuestions}
                      /> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Stepper;
